import { EventEmitter, Injectable, Output } from '@angular/core';
import { DataService } from './data.service';
import { Subject } from 'rxjs';
import { BusinesLogicService } from './business-logic.service';
import { take } from 'rxjs/operators';
import { NotificationService } from './notification.service';
import { LanguagePipe } from './language.pipe';
import { ModalHelper } from '../components/modal/modal.helper';

declare var $;

@Injectable()
export class TurnService {
  @Output() isCallLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
  private autoNotifyInterval: any = null;
  private autoSupervisorTimeout: any = null;
  public callLoading: boolean = false;

  constructor(
    private _data: DataService,
    private _blogic: BusinesLogicService,
    private _notify: NotificationService,
    private _modal: ModalHelper,
    private _lang: LanguagePipe
  ) { }

  startAutoSupervisor() {
    clearTimeout(this.autoSupervisorTimeout);
    if (this._data.session['autosupervisor'] && this._data.turn == null) {
       this.autoSupervisorTimeout = setTimeout(() => {
        if (this._data.inQueue > 0 && !this._data.deskStopped && !this._data.pauseModalTurn && !this._data.redError) {
           this.call();
        }
      }, parseInt((this._data.session['autosupervisor_delaytime'])) * 1000);
    }
  }

  stopAutoSupervisor() {
    clearTimeout(this.autoSupervisorTimeout);
  }

  enableAutoNotifyInBackground() {
    clearInterval(this.autoNotifyInterval);
    if (this._data.configuration["autoCheckQueues"]) {
      this.autoNotifyInterval = setInterval(() => {
        if (this._data.inQueue > 0 && this._notify.hasPermission() && this._data.turn == null) {
          this._notify.notify(this._lang.transform("notifyTitle"), this._lang.transform("notifyBodyInWaitingPart1") + this._data.inQueue + this._lang.transform("notifyBodyInWaitingPart2"))
        }
      }, (this._data.configuration["autoCheckQueuesTime"] * 60) * 1000);
    }
  }

  disableAutoNotifyInBackground() {
    clearInterval(this.autoNotifyInterval);
  }

  startDeskAutomations() {
    this.enableAutoNotifyInBackground();
    this.startAutoSupervisor();
  }

  stopDeskAutomations() {
    this.disableAutoNotifyInBackground();
    this.stopAutoSupervisor();
  }

  public call(id: number = null): void {

    this.callLoading = true;
    this.isCallLoading.emit(true);

    let params: object = {
      desk_id: this._data.session["desk"],
      status: "A",
      deskuser: this._data.session["username"],
      deskoperator: this._data.session["operator"],
    };

    this._blogic.deskNotify(params)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this._data.actionContainer = 0;
          if (response != null) {
            if (response["turn_id"] == "-1") {
              this._data.closeTurn();
            } else {
              this._data.turn = response;
              this._data.lastCalls.unshift(response);
            }

          }

          $("#refreshList").trigger('click');
          this.callLoading = false;
          this.isCallLoading.emit(false);
        },
        (error: any) => {
          this.callLoading = false;
          this.isCallLoading.emit(false);
        }
      );
  }

  public recall(): void {
    var actualTurnId = null;
    var params: object;
    if (this._data.enableRecallSupervisor) {
      actualTurnId = this._data.selectedTurn['id'];
      params = {
        desk_id: this._data.selectedTurn['desk_id'],
        deskuser: this._data.session["username"],
        deskoperator: this._data.session["operator"],
      };
    } else {
      actualTurnId = this._data.turn['id'];
      params = {
        desk_id: this._data.session["desk"],
        deskuser: this._data.session["username"],
        deskoperator: this._data.session["operator"]
      };
    }

    this.callLoading = true;
    this.isCallLoading.emit(true);

    this._blogic.recallTurn(params)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this._data.actionContainer = 0;
          if ((this._data.selectedTurn != null && this._data.selectedTurn['desk']) == this._data.session['desk']) {
            this._data.turn = response;
            this._data.selectedTurn = null;
          }

          let turnsFound = this._data.turnStatusInViewer.findIndex(e => e["turn_id"] == actualTurnId);

          if (turnsFound == -1) {
            this._data.lastCalls.unshift(response);
          } else {
            this._data.turnStatusInViewer = this._data.turnStatusInViewer.filter(item => item["turn_id"] !== actualTurnId);
          }
          this.callLoading = false;
          this.isCallLoading.emit(false);
        },
        (error) => {
          this.callLoading = false;
          this.isCallLoading.emit(false);
        }
      );
  }

  public callList(): void {
    this.callLoading = true;
    this.isCallLoading.emit(true);
    let self = this;
    if (this._data.configuration["activeSupervisor"] && this._data.configuration["questSupervisorDesk"]) {
      $('#desksModal').on('hidden.bs.modal', function () {
        self.callLoading = false;
        self.isCallLoading.emit(false);
      });
      this._modal.show("desksModal");
    } else {
      this.actionCallList(this._data.session["desk"]);
    }
  }

  public actionCallList(desk: number): void {

    let params: object = [];

    if (this._data.configuration["activeSupervisor"]) {
      params = {
        desk_id: desk,
        turn_id: this._data.selectedTurn["id"],
        queue_id: this._data.selectedTurn["queue_id"],
        action: this._data.configuration["actionToCall"],
        deskuser: this._data.session["username"],
        deskoperator: this._data.session["operator"],
      };
    } else {
      params = {
        desk_id: desk,
        queue_id: this._data.selectedTurn["queue_id"],
        turn_id: this._data.selectedTurn["id"],
        deskuser: this._data.session["username"],
        deskoperator: this._data.session["operator"]
      };
    }

    this._blogic.setTurn(params)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          this._data.actionContainer = 0;
          if (response["id"] == "-1") {
            this._data.closeTurn();
          } else {
            if (desk == this._data.session["desk"]) {
              this._data.turn = response;
              this._data.lastCalls.unshift(response);
            }
          }
          this._modal.hide("desksModal");
          this.callLoading = false;
          this.isCallLoading.emit(false);
          this._data.selectedTurn = null;
        }
      );
  }
}
